module.exports = __webpack_public_path__ + "static/media/glossaries_ru.1aa558ac.jpg";